import { MatExpansionModule } from '@angular/material/expansion';
import { MExpansionPanel } from './components/m-expansion-panel/m-expansion-panel';
import { MDisclaimerComponent } from './components/m-disclaimer/m-disclaimer.component';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// import "@serasa/seds-components/dist/eds-spinner";
import {MatCheckboxModule} from '@angular/material/checkbox';

import { NgxMaskModule } from 'ngx-mask';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthenticationComponent } from './auth/authentication/authentication.component';
import { CardIconComponent } from './components/card-icon/card-icon.component';
import { CardLinkComponent } from './components/card-link/card-link.component';
import { DisclaimerComponent } from './components/disclaimer/disclaimer.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { FooterLgpdComponent } from './components/footer-lgpd/footer-lgpd.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { LoadingComponent } from './components/loading/loading.component';
import { MobileMenuComponent } from './components/mobile-menu/mobile-menu.component';
import { ModalErroComponent } from './components/modal-erro/modal-erro.component';
import { ModalSidebarComponent } from './components/modal-sidebar/modal-sidebar.component';
import { ModalSidebarService } from './components/modal-sidebar/modal-sidebar.service';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { SubMenuComponent } from './components/sub-menu/sub-menu.component';
import { ProofLifeComponentsModule } from './features/proof-of-life/components/components.module';
import { FormImagesComponent } from './features/proof-of-life/form-images/form-images.component';
import { FormOptinComponent } from './features/proof-of-life/form-optin/form-optin.component';
//Prova de vida
import { ProofOfLifeComponent } from './features/proof-of-life/proof-of-life.component';
import { ProofOfLifeModule } from './features/proof-of-life/proof-of-life.module';
import { AuthInterceptor } from './interceptor/auth-interceptor';
import { DiretosCorrecaoComponent } from './pages/diretos-correcao/diretos-correcao.component';
import { DirecionamentoDeOfertasComponent } from './pages/gestao-do-consentimento/direcionamento-de-ofertas/direcionamento-de-ofertas.component';
import { GerenciarPreferenciasComponent } from './pages/gestao-do-consentimento/gerenciar-preferencias/gerenciar-preferencias.component';
import { DeclaracaoCompletaComponent } from './pages/historico-solicitacoes/declaracao-completa/declaracao-completa.component';
import { DirecionamentoOfertasComponent } from './pages/historico-solicitacoes/direcionamento-ofertas/direcionamento-ofertas.component';
import { HistoricoSolicitacoesComponent } from './pages/historico-solicitacoes/historico-solicitacoes.component';
import { ComoProtegemosSeusDadosComponent } from './pages/landing/como-protegemos-seus-dados/como-protegemos-seus-dados.component';
import { ConhecaNossoTrabalhoComponent } from './pages/landing/conheca-nosso-trabalho/conheca-nosso-trabalho.component';
import { ConhecaSeusDireitosComponent } from './pages/landing/conheca-seus-direitos/conheca-seus-direitos.component';
import { FinalidadesDeUsoComponent } from './pages/landing/finalidades-de-uso/finalidades-de-uso.component';
import { RelatorioAnaliticoComponent } from './pages/relatorio-analitico/relatorio-analitico.component';
import { RelatorioAnaliticoService } from './pages/relatorio-analitico/relatorio-analitico.service';
import { CardsFooterComponent } from './pages/relatorio-sintetico/cards-footer/cards-footer.component';
import { BlocoAvisosDividasSerasaComponent } from './pages/relatorio-sintetico/dividas-pendentes/avisos-dividas/bloco-avisos-dividas-serasa/bloco-avisos-dividas-serasa.component';
import { BlocoDividasParceirosComponent } from './pages/relatorio-sintetico/dividas-pendentes/parceiros/bloco-dividas-parceiros.component';
import { BlocoDividasAcoesJudiciaisComponent } from './pages/relatorio-sintetico/dividas-pendentes/publicas/acoes-judiciais/bloco-dividas-acoes-judiciais.component';
import { BlocoDividasChequeSemFundoComponent } from './pages/relatorio-sintetico/dividas-pendentes/publicas/cheque-sem-fundo/bloco-dividas-cheque-sem-fundo.component';
import { BlocoDividasParticipacaoFalenciaComponent } from './pages/relatorio-sintetico/dividas-pendentes/publicas/participacao-falencia/bloco-dividas-participacao-falencia.component';
import { BlocoDividasProtestosComponent } from './pages/relatorio-sintetico/dividas-pendentes/publicas/protestos/bloco-dividas-protestos.component';
import { BlocoDividasSerasaComponent } from './pages/relatorio-sintetico/dividas-pendentes/serasa/bloco-dividas-serasa.component';
import { BlocoDividasSerasaService } from './pages/relatorio-sintetico/dividas-pendentes/serasa/bloco-dividas-serasa.service';
import { ConsultaSerasaLockUnlockComponent } from './pages/relatorio-sintetico/historico-consultas/consulta-serasa-lock-unlock/consulta-serasa-lock-unlock.component';
import { ConsultasParceirosComponent } from './pages/relatorio-sintetico/historico-consultas/consultas-parceiros/consultas-parceiros.component';
import { ConsultasSerasaComponent } from './pages/relatorio-sintetico/historico-consultas/consultas-serasa/consultas-serasa.component';
import { BlocoDividasRegularizadasParceirosComponent } from './pages/relatorio-sintetico/historico-credito/dividas-regularizadas-parceiros/bloco-dividas-regularizadas-parceiros.component';
import { BlocoDividasRegularizadasAcoesJudiciaisComponent } from './pages/relatorio-sintetico/historico-credito/dividas-regularizadas-publicas/acoes-judiciais/bloco-dividas-regularizadas-acoes-judiciais.component';
import { BlocoDividasRegularizadasChequeSemFundosComponent } from './pages/relatorio-sintetico/historico-credito/dividas-regularizadas-publicas/cheque-sem-fundos/bloco-dividas-regularizadas-cheque-sem-fundos.component';
import { BlocoDividasRegularizadasProtestosComponent } from './pages/relatorio-sintetico/historico-credito/dividas-regularizadas-publicas/protestos/bloco-dividas-regularizadas-protestos.component';
import { BlocoDividasRegularizadasSerasaComponent } from './pages/relatorio-sintetico/historico-credito/dividas-regularizadas-serasa/bloco-dividas-regularizadas-serasa.component';
import { BlocoInformacoesPositivasComponent } from './pages/relatorio-sintetico/historico-credito/informacoes-positivas/bloco-informacoes-positivas.component';
import { InformacoesCadastraisComponent } from './pages/relatorio-sintetico/informacoes-cadastrais/informacoes-cadastrais.component';
import { BlocoNotaCreditoComponent } from './pages/relatorio-sintetico/nota-credito/bloco-nota-credito.component';
import { ParticipacaoSocietariaComponent } from './pages/relatorio-sintetico/participacao-societaria/participacao-societaria.component';
import { ProtocoloComponent } from './pages/relatorio-sintetico/protocolo/protocolo.component';
import { RelatorioSinteticoComponent } from './pages/relatorio-sintetico/relatorio-sintetico.component';
import { RelatorioSinteticoService } from './pages/relatorio-sintetico/relatorio-sintetico.service';
import { MoedaRealPipe } from './pipes/moeda-real.pipe';
import { NaoinformadoPipe } from './pipes/naoinformado.pipe';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AlertComponent } from './components/alert/alert.component';
import {MatFormFieldModule,  } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {MatDialogModule} from '@angular/material/dialog';
import { MDialogComponent } from './components/m-dialog/m-dialog.component';
import {MatButtonModule} from '@angular/material/button';
import { MSolicitarRelatorioAnaliticComponent } from './pages/m-solicitar-relatorio-analitic/m-solicitar-relatorio-analitic.component';
import {MatSelectModule} from '@angular/material/select';


@NgModule({
  declarations: [
    AppComponent,
    RelatorioSinteticoComponent,
    NaoinformadoPipe,
    RelatorioAnaliticoComponent,
    ConhecaSeusDireitosComponent,
    CardLinkComponent,
    SubMenuComponent,
    FooterComponent,
    DisclaimerComponent,
    MoedaRealPipe,
    ProofOfLifeComponent,
    FormOptinComponent,
    FormImagesComponent,
    ConhecaNossoTrabalhoComponent,
    FinalidadesDeUsoComponent,
    CardIconComponent,
    ModalSidebarComponent,
    BlocoDividasSerasaComponent,
    BlocoDividasAcoesJudiciaisComponent,
    ComoProtegemosSeusDadosComponent,
    BlocoDividasProtestosComponent,
    BlocoDividasChequeSemFundoComponent,
    BlocoDividasParticipacaoFalenciaComponent,
    BlocoDividasParceirosComponent,
    HeaderComponent,
    MobileMenuComponent,
    BlocoDividasRegularizadasSerasaComponent,
    BlocoDividasRegularizadasAcoesJudiciaisComponent,
    BlocoDividasRegularizadasProtestosComponent,
    GerenciarPreferenciasComponent,
    BlocoInformacoesPositivasComponent,
    BlocoDividasRegularizadasChequeSemFundosComponent,
    AuthenticationComponent,
    DirecionamentoDeOfertasComponent,
    FooterLgpdComponent,
    LoadingComponent,
    BlocoNotaCreditoComponent,
    ProtocoloComponent,
    ErrorPageComponent,
    DiretosCorrecaoComponent,
    HistoricoSolicitacoesComponent,
    DeclaracaoCompletaComponent,
    DirecionamentoOfertasComponent,
    ParticipacaoSocietariaComponent,
    InformacoesCadastraisComponent,
    ConsultasParceirosComponent,
    ConsultasSerasaComponent,
    ModalErroComponent,
    BlocoAvisosDividasSerasaComponent,
    BlocoDividasRegularizadasParceirosComponent,
    NavBarComponent,
    ConsultaSerasaLockUnlockComponent,
    CardsFooterComponent,
    MDisclaimerComponent,
    MExpansionPanel,
    AlertComponent,
    MDialogComponent,
    MSolicitarRelatorioAnaliticComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    ProofOfLifeModule,
    ProofLifeComponentsModule,
    NgxMaskModule.forRoot(),
    CommonModule,
    BrowserAnimationsModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    MatSelectModule,
    MatCheckboxModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,

    },
    {provide: LOCALE_ID, useValue: 'pt-BR' },
    {provide: 'googleTagManagerId', useValue: environment.gaTrackingId},
    RelatorioSinteticoService,
    RelatorioAnaliticoService,
    ModalSidebarService,
    BlocoDividasSerasaService,
    HttpClientModule
  ],
  bootstrap: [
    AppComponent,
    SubMenuComponent,
    HeaderComponent,
    FooterComponent
  ]
})
export class AppModule {

}
